module.exports = __webpack_public_path__ + "static/img/order-sub-icon.96c50264.png";